<template>
  <div class="zhengu-text2">
    <div class="zhengu-text2-content" v-html="content"></div>
  </div>
</template>

<script>
export default {
  props: {
    configData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    let content = "";
    if (this.configData.data && this.configData.data.content) {
      content = this.configData.data.content;
    }
    return {
      content: content,
    };
  },
};
</script>
